import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const SHIP_IT: WidgetPreset = {
  id: "ship-it",
  label: "Ship It! 🚀",
  defaultWidth: 182,
  defaultHeight: 80,
  html: templateHtml,
};
